import styled,{keyframes} from 'styled-components';
import discord from './imgs/discord.png';
import github from './imgs/github.png';
import instagram from './imgs/instagram.png';
const HeaderContainer = styled.div`
    display: grid;
    margin-top: 150px;
    grid-auto-flow: column;
`;

const Header = styled.div`
    width: 200px;
    height: 200px;
    background-color: #11111;
    border: 1px solid #000000;
    box-shadow: 0px 8px 30px #000000;
    border-radius: 15px;
`;

const HeaderImg = styled.div`
    img {
        display: flex;
        margin-top: 20px;
    }
`;

const HeaderSpan = styled.span`
    display: flex;
    margin-left: ${props=>props.marginLeft};
    margin-top: 20px;
    font-family: 'Fira code';
    font-style: normal;
    font-weight: 450;
    font-size: 24px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #000000;
`;

const KeyAnim = keyframes`
    from{
        background-color: transparent;  
    }
    to{
        background-color: #000000;    
    }
`;
const HeaderAnim = styled.h2`
    position:relative;
    width: 10px;
    height: 25px;
    left: ${props => props.Left};
    top: -5px;
    animation: ${KeyAnim} 500ms linear infinite;
`;
const Contatos = () => {
    return (
        <HeaderContainer>
            <Header>
                <HeaderImg>
                    <img src={discord} />
                    <HeaderSpan marginLeft="50px">fx#3834{<HeaderAnim Left="-15px"/>}</HeaderSpan>
                </HeaderImg>
            </Header>
            <Header>
                <HeaderImg>
                    <img src={github} />
                    <HeaderSpan marginLeft="85px">Fx{<HeaderAnim Left="-35px"/>}</HeaderSpan>
                </HeaderImg>
            </Header>
            <Header>
                <HeaderImg>
                    <img src={instagram} />
                    <HeaderSpan marginLeft="5px">Arthurzinh04{<HeaderAnim Left="-5px"/>}</HeaderSpan>
                </HeaderImg>
            </Header>
        </HeaderContainer>
    );
};
export default Contatos;
